import ApiService from '../apiservice'

export default class ResumoIntimacaoIaService extends ApiService {
  constructor() {
    super('/resumo-intimacao-ia');
  }

  gerarResumo(codigoIntimacao) {
    return this.post(`/${codigoIntimacao}`);
  }

  consultarHistorico(codigoIntimacao) {
    return this.get(`/${codigoIntimacao}`);
  }
}
